import BREAKPOINTS from '@lib/constants/breakpoints';
import COLORS from '@lib/constants/colors';
import env from '@lib/constants/env';
import { BreadcrumbJsonLd } from 'next-seo';
import Link from 'next/link';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.nav`
  .breadcrumb-item {
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    margin-right: 0;
    position: relative;
    transition: all 0.25s ease-in-out;

    a {
      color: ${COLORS.pink};
      text-decoration: none;
      transition: box-shadow 0.1s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  .breadcrumbs svg {
    height: 10px;
    margin-left: 1rem;
    margin-right: 1rem;
    width: 10px;
  }

  @media (min-width: ${BREAKPOINTS.medium}) {
    .breadcrumbs {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
    }

    .breadcrumb-item {
      display: inline-block;
    }
  }

  .breadcrumbs {
    padding-left: 0;
  }

  dl,
  ol,
  ul {
    margin-top: 0;
  }
`;

const BreadCrumbs = ({
  links,
}: {
  links: { label: string | number; href?: string; name?: string }[];
}) => (
  <Wrapper aria-label="breadcrumb">
    <BreadcrumbJsonLd
      itemListElements={links.map((item, index) => ({
        position: index + 1,
        item: `${env.baseUrl}${item.href}`,
        name: item.name || item.label.toString(),
      }))}
    />
    <ol className="breadcrumbs">
      {links.map(({ href, label }, index) => (
        <li key={label} className="breadcrumb-item">
          {href && links.length - 1 !== index ? (
            <>
              <Link passHref href={href}>
                <a>{label}</a>
              </Link>
              <svg
                height="20"
                viewBox="0 0 13 20"
                width="13"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0,2.36,2.38,0,12.5,10,2.38,20,0,17.64,7.73,10Z"
                  fill="#0a0c0e"
                />
              </svg>
            </>
          ) : (
            label
          )}
        </li>
      ))}
    </ol>
  </Wrapper>
);

export default BreadCrumbs;
